import { Box, Tab, TabList, TabPanels, TabPanel, Tabs } from '@chakra-ui/react';

import { useTranslation } from 'helpers/languages/translations';
import { useTabNavigate } from 'router/tabsMapper';

import PageHeader from 'layout/pageHeader';
import MListsViewer from './components/Molecules/MListsViewer';
import { useGetUserInfoSelector, useGetUserToolsSelector } from 'core/redux/selectors/authSelectors';

const PATH = 'list-management';
const ID = 'cdm_listmanager';
const NAME = 'page.list';

const ListManagement = () => {
    const translate = useTranslation();
    const { tabIndex, setTabIndex } = useTabNavigate('list-management');
    const userTools = useGetUserToolsSelector();

    const hasDashboard = userTools?.includes(1) || userTools?.includes(4);
    const hasDatafield = userTools?.includes(2);

    const userInfo = useGetUserInfoSelector();
    const readonly = !userInfo?.user_groups?.includes(22);

    const renderTabs = () => (
        <Tabs size="sm" isLazy onChange={(index) => setTabIndex(index)} index={tabIndex}>
            <TabList>
                {hasDashboard && <Tab _focus={{ boxshadow: 'none' }}>{translate('list.dashboard')}</Tab>}
                {hasDatafield && <Tab _focus={{ boxshadow: 'none' }}>{translate('list.datafield')}</Tab>}
            </TabList>
            <TabPanels>
                {hasDashboard && (
                    <TabPanel px="0">
                        <MListsViewer toolId={1} readonly={readonly} />
                    </TabPanel>
                )}
                {hasDatafield && (
                    <TabPanel px="0">
                        <MListsViewer toolId={2} readonly={readonly} />
                    </TabPanel>
                )}
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'list' }} pageTitle={translate('page.list') as string} readonly={readonly} />
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { ID, PATH, NAME };
export default ListManagement;
